<template>
  <div class="popupbox">
    <div class="logo">
      <img src="@/assets/image/logo.png" :alt="$t('layout.logo.alt')">
    </div>
    <h3>{{ $t('idenForm.title') }}</h3>
    <div>
      <iden-app-form @success="$emit('success')" @failed="$emit('failed')"/>
    </div>
  </div>
</template>
<script>
import IdenAppForm from '@/components/IDEN/IdenAppForm.vue';

export default {
  name: 'idenForm',
  components: {
    IdenAppForm,
  },
  data: () => ({
    tabItem: [],
  }),
  methods: {
  },
  created(){
    this.tabItem = [
      {title: this.$t('idenForm.tabApp')},
    ];
  },
};
</script>
<style lang="scss" scoped>
  .popupbox {
    padding: 20px;
  }
  .logo {
    width: 120px;
    height: 50px;
    margin: 0 auto;
    margin-top: 30px;
  }
  h3 {
    text-align: center;
    margin-top: 10px;
    border-top: 1px solid #ddd;
    padding-top: 10px;
    color: #555;
  }
  .sheet {
    width: 94%;
    margin: 0 auto;
    margin-top: 10px;
  }
</style>
